import _ from 'lodash';

// notification types
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const ERROR = 'error';

// Actions
const NEW_NOTIFICATION = 'notifications/NEW_NOTIFICATION';
const EXPIRE_NOTIFICATION = 'notifications/EXPIRE_NOTIFICATION';

// Action creators
const notify = (msg, notificationType) => ({
  type: NEW_NOTIFICATION,
  msg,
  id: _.uniqueId(msg),
  notificationType,
});

export const notifySuccess = msg => notify(msg, SUCCESS);
export const notifyWarning = msg => notify(msg, WARNING);
export const notifyError = msg => notify(msg, ERROR);

export const expireNotification = id => ({
  type: EXPIRE_NOTIFICATION,
  id,
});

// Reducer

const initialState = {
  notifications: {},
};

export const notificationState = (state = initialState, action) => {
  switch (action.type) {
    case NEW_NOTIFICATION: {
      const newNotification = {
        [action.id]: {
          msg: action.msg,
          type: action.notificationType,
        },
      };
      return { ...state, notifications: newNotification };
    }
    case EXPIRE_NOTIFICATION: {
      const notifications = _.omit(state.notifications, action.id);
      return { ...state, notifications };
    }
    default: {
      return state;
    }
  }
};
